import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { contactInfo } from '../data/mockData';
import VedLogo from './VedLogo';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="mb-4">
              <VedLogo size="md" showText={false} />
              <h3 className="text-xl font-bold mt-2">Ved Homestays</h3>
              <p className="text-xs text-orange-400">Varanasi</p>
            </div>
            <p className="text-gray-300 text-sm mb-4">
              Experience authentic Banarasi hospitality near Kashi Vishwanath Temple and Ganga Ghats.
            </p>
            <p className="text-orange-400 font-medium text-sm">
              Live in Banaras like a Banarasi
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/rooms" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  Rooms & Pricing
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/admin/login" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  Admin Login
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  Contact & Booking
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone size={16} className="text-orange-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">{contactInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={16} className="text-orange-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">{contactInfo.email}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="text-orange-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">{contactInfo.address}</span>
              </li>
            </ul>
          </div>

          {/* Social & Nearby */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
            <div className="flex space-x-3 mb-6">
              <a href="#" className="w-9 h-9 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-9 h-9 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <Instagram size={18} />
              </a>
              <a href="#" className="w-9 h-9 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <Twitter size={18} />
              </a>
            </div>
            <div>
              <h5 className="text-sm font-semibold mb-2">Nearby Attractions</h5>
              <ul className="space-y-1 text-gray-300 text-sm">
                <li>• Kashi Vishwanath Temple</li>
                <li>• Dashashwamedh Ghat</li>
                <li>• Manikarnika Ghat</li>
                <li>• Assi Ghat</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Ved Homestays. All rights reserved. | Designed with love for Varanasi
          </p>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
